import Component from './input_range_form.vue'
export default Component
